"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showDate = showDate;
function showDate(date) {
    return `${new Date(date).toISOString().split('T')[0]}`;
}
//# sourceMappingURL=date.js.map